import {BaseMyopMessage} from "./BaseMessage";

export class EnvelopedMessage extends BaseMyopMessage {
    messageType = 'EnvelopedMessage';

    constructor(public destination: string, public message: BaseMyopMessage) {
        super();

        const innerEnvelopedMessage = (message as EnvelopedMessage);
        this.route = [destination, ...innerEnvelopedMessage.route ? innerEnvelopedMessage.route : []];
    }
}
